import type { ChunkHit } from '../types';
import { onCitationClick } from '../audio/player';

function formatTimestamp(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}

export function ChunkList({ chunks }: { chunks: ChunkHit[] }) {
  if (chunks.length === 0) return null;
  return (
    <ul className="chunk-list">
      {chunks.map((ch) => (
        <li key={ch.chunk_id}>
          <header className="chunk-card-head">
            <span className="episode">{ch.episode_id}</span>
            <button
              className="play-link"
              onClick={() => onCitationClick({
                episode_id: ch.episode_id,
                start_sec: ch.start_sec,
                end_sec: ch.end_sec,
                label: `${ch.episode_id} — ${formatTimestamp(ch.start_sec)}`,
              })}
            >
              {formatTimestamp(ch.start_sec)}
            </button>
          </header>
          <p className="chunk-text">{ch.text.slice(0, 600)}{ch.text.length > 600 ? '…' : ''}</p>
          <footer className="chunk-card-foot">
            {ch.bm25_rank !== null && <span className="rank">bm25 #{ch.bm25_rank}</span>}
            {ch.dense_rank !== null && <span className="rank">dense #{ch.dense_rank}</span>}
          </footer>
        </li>
      ))}
    </ul>
  );
}
